// constants
import { USER_TOKEN_COOKIE_NAME } from "../../constants/user";

/**
 * Récupère le token d’authentification
 */
export default function nextGetAuthToken({ cookies }) {
  return cookies[USER_TOKEN_COOKIE_NAME];
}
